import type { LoaderFunction } from 'react-router';

import { PAGE_SIZE } from 'src/core/domain/constants';
import { getAuthStatus } from 'src/core/utils/authUtil';
import { getCategoryIdAndPageNumberFromFullUrl } from 'src/core/utils/categoryUtil';
import { getCurrentPageNumber } from 'src/core/utils/pageUtil';
import logger from 'src/modules/logger/logger';
import {
  fetchCategoryThreads,
  type fetchCategoryThreadsParams,
} from 'src/services/threadsService';
import type { RouteProps } from 'src/types';

export const communityGroupsLoader =
  ({ config, client }: RouteProps): LoaderFunction =>
  async ({ params }) => {
    try {
      const isAuthenticated = await getAuthStatus();
      const pageNumber = getCurrentPageNumber(config);

      const { absoluteUrl } = config;
      const { categoryId } = getCategoryIdAndPageNumberFromFullUrl(
        absoluteUrl,
        params,
      );

      const param: fetchCategoryThreadsParams = {
        categoryId,
        cursor: (pageNumber - 1) * PAGE_SIZE,
        hasLearningProfile: isAuthenticated,
        client,
        pageSize: PAGE_SIZE,
        config,
      };
      const result = await fetchCategoryThreads(param);

      return {
        groupThreads: result,
        isAuthenticated,
        init: true,
      };
    } catch (error) {
      logger.error({ error }, 'communityGroupsLoader');
      throw error;
    }
  };
